import React, { useRef } from 'react';

import ModalVideo from '../ModalVideo';
import { MiguelTamara_Video2 } from '../../../../../utils/EN/Modals/aiArtists';

const ModalVideoMiguelTamara2 = () => {
  return (
    <>
      <ModalVideo
        id="miguel-tamara-video-2"
        dataText={MiguelTamara_Video2}
        videoSrc="https://www.youtube.com/embed/k2CbzJujEzQ"
        videoTitle="KUTER_STUDIO_AI_MIGUEL_TAMARA_VIDEO_2"
      />
    </>
  );
};

export default ModalVideoMiguelTamara2;
